module.exports = __webpack_public_path__ + "img/oscommers.fcc7022b.jpg";